type CartViewportInput = {
  height: number;
  parentOffset: number;
  offset: number;
  iframeHeight?: number | null;
  fixedHeaderHeight?: number;
  fixedFooterHeight?: number;
};

const finiteOrZero = (value: number): number => (Number.isFinite(value) ? value : 0);
const clamp = (value: number, upper: number): number => Math.min(upper, Math.max(0, value));
const validInset = (value: number | undefined, height: number): number =>
  typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= height ? value : 0;

export function getCartViewport({
  height,
  parentOffset,
  offset,
  iframeHeight,
  fixedHeaderHeight,
  fixedFooterHeight,
}: CartViewportInput): { top: number; height: number } {
  const viewportHeight = Math.max(0, finiteOrZero(height));
  const scrollOffset = finiteOrZero(parentOffset);
  if (typeof iframeHeight !== 'number' || !Number.isFinite(iframeHeight) || iframeHeight < 0) {
    // Before the iframe reports its height, retain finite legacy positioning.
    const legacyOffset = validInset(offset, viewportHeight);
    return { top: Math.max(0, scrollOffset + legacyOffset), height: viewportHeight - legacyOffset };
  }

  // The general offset also supports cached SDKs that omit header/scroll-relative fields.
  const topInset = Math.max(validInset(fixedHeaderHeight, viewportHeight), validInset(offset, viewportHeight));
  const lower = clamp(scrollOffset + topInset, iframeHeight);
  const upper = clamp(scrollOffset + viewportHeight - validInset(fixedFooterHeight, viewportHeight), iframeHeight);
  return { top: lower, height: Math.max(0, upper - lower) };
}
